import React, {useEffect, useState} from 'react';
import Address from "../components/survey/Address";
import Title from "../components/survey/Title";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {store} from "react-notifications-component";
import {configureAnchors} from "react-scrollable-anchor";
import Survey0 from "../components/survey/Survey0";
import Survey1 from "../components/survey/Survey1";
import Survey2 from "../components/survey/Survey2";
import Survey3 from "../components/survey/Survey3";
import Survey4 from "../components/survey/Survey4";
import Survey5 from "../components/survey/Survey5";
import Survey6 from "../components/survey/Survey6";
import Survey7 from "../components/survey/Survey7";
import Survey8 from "../components/survey/Survey8";
import Survey9 from "../components/survey/Survey9";
import Survey10 from "../components/survey/Survey10";
import Survey11 from "../components/survey/Survey11";
import Survey12 from "../components/survey/Survey12";
import Survey13 from "../components/survey/Survey13";
import Survey14 from "../components/survey/Survey14";
import Survey15 from "../components/survey/Survey15";
import FaqImg from "../assets/faq.png";
import Survey16 from "../components/survey/Survey16";

import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    agreeDataState,
    answerState,
    familyState,
    menuDataState, rentState, seqState, simpleFileState,
    stepState,
    surveyDataState,
    userState
} from "../state/globalState";
import Survey17 from "../components/survey/Survey17";
import Survey2_1 from "../components/survey/Survey2_1";
import client from "../lib/api/client";

const useStyles = makeStyles(theme => ({
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    fab: {
        margin: 0,
        width: 100,
        height: 34,
        top: 'auto',
        right: 25,
        bottom: 62,
        left: 'auto',
        position: 'fixed',
        filter: 'drop-shadow(3px 3px 3px #222)',
        '&:hover': {
            filter: 'drop-shadow(1px 1px 1px #222)'
        },
        [theme.breakpoints.up(600)]: {
            margin: 0,
            width: 'auto',
            height: 'auto',
            top: 'auto',
            right: 40,
            bottom: 50,
            left: 'auto',
            position: 'fixed',
            filter: 'drop-shadow(3px 3px 3px #222)',
            '&:hover': {
                filter: 'drop-shadow(1px 1px 1px #222)'
            },
        }
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 28px',
        height: 35,
        fontSize: "14px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    }
}));
let compRefs = [];

const SurveyForm = ({ history }) => {
    const [userInfo, setUserInfo] = useRecoilState(userState);
    const [agreeData, setAgreeData] = useRecoilState(agreeDataState);
    const [surveyData, setSurveyData] = useRecoilState(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const seq = useRecoilValue(seqState);
    const family = useRecoilValue(familyState);
    const rent = useRecoilValue(rentState);
    const setMenuData = useSetRecoilState(menuDataState);
    const setStep = useSetRecoilState(stepState);
    const simpleFiles = useRecoilValue(simpleFileState);
    const classes = useStyles();
    const [isProcess, setIsProcess] = useState(false);

    configureAnchors({offset: -80, scrollDuration: 400});

    useEffect(() => {
        const TIME_ZONE = 3240 * 10000;
        const d = new Date();
        const date = new Date(+d + TIME_ZONE).toISOString();

        setAnswer((prev) => ({
            ...prev,
            svySttDate: date,
        }));
    }, []);

    useEffect(() => {
        if (seq !== "" && seq !== undefined && seq !== null) {
            client.post('/kognr/logout').then(response => {
                if (response.data.success) {
                    localStorage.clear();
                    history.replace("/");
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [seq]);

    useEffect(() => {
        if (simpleFiles.length > 0) {
            const blobUrl = `https://taxtronstorageaccount.blob.core.windows.net/hc056002/${simpleFiles[0].fileUuid}`;
            setAnswer((prev) => ({
                ...prev,
                fileUrl: blobUrl,
            }));
        }

        // if (!surveyData) {
        //     loadInitData(userInfo.corprInfoDiviNo);
        // }
        // const CORPR = JSON.parse(localStorage.getItem("CORPR_BASE_INFO"));
        // dispatch(setCorprInfo(CORPR));

        // setKoFileAttchYn(CORPR.koFileAttchYn);
    }, [simpleFiles]);

    const showNoti = (msg) => {

        store.addNotification({
            title: "알림",
            message: msg,
            type: 'warning',
            insert: "top",
            container: "top-center",
            animationIn: ["animated", "flipInY"],
            animationOut: ["animated", "flipOutY"],
            dismiss: {
                duration: 3000,
                onScreen: false
            },
            width: 500
        });
    };

    const loadInitData = (corprInfoDiviNo) => {
        try {
            setAgreeData(agreeData);
            setSurveyData(surveyData);

            const agreeTitle = agreeData.map((item) => ({
                title: item.title,
                isChecked: false
            }));

            let surveyTitle = surveyData.map((item) => {
                if (item.type !== 'title') {
                    return {
                        treeTitle: (item.treeTitle === "" || item.treeTitle === undefined)? item.title : item.treeTitle,
                        hide: item.hide,
                        isChecked: false
                    };
                } else {
                    return {
                        treeTitle: item.title,
                        hide: undefined,
                        isChecked: false
                    }
                }
            });

            let menu = {};
            agreeTitle.forEach((value, key) => {
                menu['AGREE_' + key] = value;
            });

            surveyTitle.forEach((value, key) => {
                // if (corprInfoDiviNo === '2235') {
                //     if (key !== 10 && key !== 12 && key !== 15 && key !== 29) {
                //         menu['SURVEY_' + key] = value;
                //     }
                // } else {
                //     menu['SURVEY_' + key] = value;
                // }
                menu['SURVEY_' + key] = value;
            });

            Object.keys(menu).forEach((key) => {
                if (key.indexOf('SURVEY') !== -1 && menu[key].hide === undefined) {
                    delete menu[key];
                }
            });

            setMenuData(menu);
            console.log('loading complete');
            // const user = localStorage.getItem('user');
            // if (!user) return;
            //
            // dispatch(tempSetUser(user));
            // dispatch(check());
        } catch (e) {
            console.log('localStorage is not working');
        }
    }

    const validationCheck = () => {
        const namePattern = /^[가-힣a-zA-Z\s]{2,20}$/;

        if (answer.tosaAgreeYn === undefined || answer.tosaAgreeYn === '' || answer.tosaAgreeYn === '0') {
            setStep(0);
            showNoti('서비스 제공을 위해서 이용 약관에 동의 하시기 바랍니다.');
            history.push('/agree#0');
            return false;

        } if (answer.dpcnAgreeYn === undefined || answer.dpcnAgreeYn === '' || answer.dpcnAgreeYn === '0') {
            setStep(0);

            showNoti('서비스 제공을 위해서 이용 약관에 동의 하시기 바랍니다.');
            history.push('/agree#0');
            return false;

        } if (answer.requiredAgreeYn === undefined || answer.requiredAgreeYn === '' || answer.requiredAgreeYn === '0') {
            setStep(0);

            showNoti('서비스 제공을 위해서 이용 약관에 동의 하시기 바랍니다.');
            history.push('/agree#0');
            return false;

        } if (answer.kdpcUniIdentAgreeYn === undefined || answer.kdpcUniIdentAgreeYn === '' || answer.kdpcUniIdentAgreeYn === '0') {
            setStep(0);

            showNoti('서비스 제공을 위해서 이용 약관에 동의 하시기 바랍니다.');
            history.push('/agree#0');
            return false;

        } if (answer.kdpcSstiIntoAgreeYn === undefined || answer.kdpcSstiIntoAgreeYn === '' || answer.kdpcSstiIntoAgreeYn === '0') {
            setStep(0);

            showNoti('서비스 제공을 위해서 이용 약관에 동의 하시기 바랍니다.');
            history.push('/agree#0');
            return false;

        } if (answer.kdpcOtherAgreeYn === undefined || answer.kdpcOtherAgreeYn === '' || answer.kdpcOtherAgreeYn === '0') {
            setStep(0);
            showNoti('서비스 제공을 위해서 이용 약관에 동의 하시기 바랍니다.');
            history.push('/agree#0');
            return false;

        } if (answer.dptyYn === undefined || answer.dptyYn === '' || answer.dptyYn === '0') {
            setStep(0);
            showNoti('서비스 제공을 위해서 이용 약관에 동의 하시기 바랍니다.');
            history.push('/agree#0');
            return false;
        }

        // 설문 필수값 체크
        if (answer.frorAgreeYn === undefined || answer.frorAgreeYn === '') {
            window.window.location.href = '/survey#0';
            showNoti('필수 입력 항목입니다.');
            return false;
        } if (answer.frorAgreeYn === '0' && (answer.frorIndividual === undefined || answer.frorIndividual === '')) {
            window.location.href = '/survey#1';
            showNoti('필수 입력 항목입니다.');
            compRefs[1].focus();
            return false;
        } if (answer.frorAgreeYn === '0' && (answer.frorRlspGcd === undefined || answer.frorRlspGcd === '')) {
            window.location.href = '/survey#2';
            showNoti('필수 입력 항목입니다.');
            return false;
        } if (answer.frorAgreeYn === '0' && (answer.frorJobTitle === undefined || answer.frorJobTitle === '')) {
            window.location.href = '/survey#3';
            showNoti('필수 입력 항목입니다.');
            compRefs[3].focus();
            return false;
        } if (answer.frorAgreeYn === '0' && (answer.frorCorpNm === undefined || answer.frorCorpNm === '')) {
            window.location.href = '/survey#4';
            showNoti('필수 입력 항목입니다.');
            compRefs[4].focus();
            return false;
        } if (answer.userNm === undefined || answer.userNm === '') {
            window.location.href = '/survey#5';
            showNoti('필수 입력 항목입니다.');
            compRefs[5].focus();
            return false;
        } if (!namePattern.test(answer.userNm)) {
            window.location.href = '/survey#5';
            showNoti('한글/영문 두 글자 이상 입력하세요.');
            compRefs[5].focus();
            return false;
        } if (answer.natlGcd === undefined || answer.natlGcd === '') {
            window.location.href = '/survey#7';
            showNoti('필수 입력 항목입니다.');
            return false;
        } if (answer.roadAddr === undefined || answer.roadAddr === '' || answer.roadAddrDetail === undefined || answer.roadAddrDetail === '') {
            window.location.href = '/survey#118';
            showNoti('필수 입력 항목입니다.');
            window.location.href = '/survey#118';
            return false;
        } if (answer.spouse === undefined || answer.spouse === '' || answer.householderYn === undefined || answer.householderYn === '') {
            window.location.href = '/survey#9';
            showNoti('필수 입력 항목입니다.');
            compRefs[9].focus();
            return false;
        } if ((answer.spouse === "사별" || answer.spouse === '이혼') && (answer.divorceDt === undefined || answer.divorceDt === '')) {
            window.location.href = '/survey#9';
            showNoti('필수 입력 항목입니다.');
            compRefs[9].focus();
            return false;
        } if (answer.telNo === undefined || answer.telNo === '') {
            window.location.href = '#10';
            compRefs[10].focus();
            return false;
        } if (answer.empNo === undefined || answer.empNo === '') {
            window.location.href = '#12';
            compRefs[12].focus();
            return false;
        } if (answer.email === undefined || answer.email === '') {
            window.location.href = '#13';
            showNoti('이메일은 필수 입력 항목입니다.');
            return false;
        } if (answer.email) {
            const mailPattern = /^([0-9a-zA-Z_.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/i;
            if(!mailPattern.test(answer.email)){
                window.location.href = '#13';
                showNoti('잘못된 이메일 형식입니다.');
                return false;
            }
        } if (answer.familyAplyYn === undefined || answer.familyAplyYn === '') {
            showNoti('필수 입력 항목입니다.');
            window.location.href = '#15';
            return false;
        } if (answer.intDiviYn === undefined || answer.intDiviYn === '') {
            showNoti('필수 입력 항목입니다.');
            window.location.href = '#18';
            return false;
        } if (answer.intYn === undefined || answer.intYn === '') {
            showNoti('필수 입력 항목입니다.');
            window.location.href = '#19';
            return false;
        } if (answer.rentYn === undefined || answer.rentYn === null || answer.rentYn === '') {
            showNoti('필수 입력 항목입니다.');
            window.location.href = '#20';
            return false;
        } if (answer.bizYn === undefined || answer.bizYn === null || answer.bizYn === '') {
            showNoti('필수 입력 항목입니다.');
            window.location.href = '#28';
            return false;
        } if (answer.etcYn === undefined || answer.etcYn === null || answer.etcYn === '') {
            showNoti('필수 입력 항목입니다.');
            window.location.href = '#29';
            return false;
        }

        if (answer.dsptSttDt && answer.dsptEndDt) {
            if (Number(answer.dsptSttDt.replace(/[^0-9]/g, "")) > Number(answer.dsptEndDt.replace(/[^0-9]/g, ""))) {
                window.location.href = '/survey#11';
                showNoti('파견일자가 잘못 입력되었습니다.');
                return false;
            }
        }

        if (answer.frorAgreeYn === '1') {
            const newState = {
                ...answer,
                frorIndividual: "",
                frorJobTitle: "",
                frorRlspGcd: "",
                frorCorpNm: "",
            };
            setAnswer(newState);
        }

        if (answer.rentYn === '0') {
            const newState = {
                ...answer,
                houseCnt: "",
                storeCnt: "",
                rentAmt: "",
                rentBusiRegYn: "0",
            };
            setAnswer(newState);
        }
        if(!validationCheckDeduction()) return false;
        if( answer['step_75'] === '1' && answer['step_78'] === '0'
            && (answer['step_119'] === undefined || answer['step_119'] === '')){
            window.location.href = '/survey#75';
            showNoti('하위 항목을 모두 입력해주세요.');
            return false;
        }
        if((answer['step_86'] === undefined || answer['step_86']=== null || answer['step_86'] === '')){
            showNoti('필수 입력 항목입니다.');
            window.location.href = '/survey#86';
            return false;
        }
        if(answer.rentYn === "1" && answer.houseCnt > 0){

        }
        return true;
    };

    const validationCheckDeduction = () => {
        const deductionSurvayList = [
            {
                step: 31,
                childSurveyStartIndex: 32,
                childSurveyEndIndex: 48,
            } ,
            {
                step: 60,
                childSurveyStartIndex: 61,
                childSurveyEndIndex: 74,
            } ,
            {
                step: 75,
                childSurveyStartIndex: 76,
                childSurveyEndIndex: 79,
            } ,
            {
                step: 81,
                childSurveyStartIndex: 82,
                childSurveyEndIndex: 85,
                additionalSteps: [{ step: 127, condition: () => answer['step_83'] === '0' }],
            } ,
            {
                step: 87,
                childSurveyStartIndex: 88,
                childSurveyEndIndex: 94,
            } ,
            {
                step: 95,
                childSurveyStartIndex: 96,
                childSurveyEndIndex: 100,
            } ,
            {
                step: 101,
                childSurveyStartIndex: 102,
                childSurveyEndIndex: 110,
            } ,
        ];

        let isValidate = true;
        let toStep;
        let notiContent = '필수 입력 항목입니다.';
        // 공제 정보 관련의 1계층 질문이 '예'일 경우 하위 질문 답변 여부 체크
        for(let i = 0; i < deductionSurvayList.length; i++){
            const stepAnswer  = answer[`step_${deductionSurvayList[i].step}`];
            if(stepAnswer === '1'){
                for(let j  = deductionSurvayList[i].childSurveyStartIndex; j <= deductionSurvayList[i].childSurveyEndIndex; j++){
                    if(!checkAndNoti(j)) {
                        isValidate = false;
                        toStep = deductionSurvayList[i].step;
                        notiContent = '하위 항목을 모두 입력해주세요.'
                        break; // 반복 종료
                    }
                }
                // 추가 step 체크 (조건부)
                if(isValidate && deductionSurvayList[i].additionalSteps) {
                    for (const extra of deductionSurvayList[i].additionalSteps) {
                        if (extra.condition() && !checkAndNoti(extra.step)) {
                            isValidate = false;
                            toStep = deductionSurvayList[i].step;
                            notiContent = '하위 항목을 모두 입력해주세요.';
                            break;
                        }
                    }
                }
            }
            if(toStep) {
                break;
            }
            if (stepAnswer === undefined || stepAnswer=== null || stepAnswer === '') {
                isValidate = false;
                toStep = deductionSurvayList[i].step;
                break; // 반복 종료
            }
        }

        if(toStep && !isValidate){
            showNoti(notiContent);
            window.location.href = `#${toStep}`;
            return false;
        }

        return true;
    }

    const checkAndNoti = (step) =>{
        const stepAnswer = answer[`step_${step}`] // 해당 스텝의 답변

        // 장기주택저당차입금: 비세대주 + 미거주 시 step 62, 64만 검증 skip
        if ((step === 62 || step === 64) && answer['step_61'] === '0' && answer['step_126'] === '0') {
            return true;
        }

        const visibleCondition = surveyData[step].visible;
        if(visibleCondition !== undefined && answer[visibleCondition.column] !== visibleCondition.value){
            setAnswer({
                ...answer,
                [stepAnswer]: ""
            })
            return true;
        }

        if (stepAnswer=== undefined || stepAnswer === null || stepAnswer === '') {
            console.log(step);
            return false;
        }
        return true;
    }

    const validationCheckFamily = (family) => {
        if (family.famyNm === undefined || family.famyNm === '') {
            showNoti('성명은 필수 입력 항목입니다.');
            return false;
        } else if (family.famySsnNo === undefined || family.famySsnNo === '') {
            showNoti('주민등록번호는 필수 입력 항목입니다.');
            return false;
        }

        if (family.famyIncodeAmt < 0) {
            showNoti('소득금액은 0 이상 입력가능합니다.');
            return false;
        }

        return true;
    };

    const onClick = (e) => {
        if (e.currentTarget.value === 'next') {

            if (validationCheck()) {
                let blobUrl = "";
                if (simpleFiles.length > 0) {
                    blobUrl = `https://taxtronstorageaccount.blob.core.windows.net/hc056002/${simpleFiles[0].fileUuid}`;
                }

                // 설문 저장
                let newState = {
                    ...answer,
                    stdYear: userInfo.stdYear,
                    corprInfoDiviNo: userInfo.corprInfoDiviNo,
                    fileUrl: blobUrl,
                    svySttDt: userInfo.svySttDt
                }

                // 부양가족 정보 저장
                let list = [];

                if (answer.familyAplyYn === '1' && (answer.onePersonHouseholdYn === "0" || answer.onePersonHouseholdYn === undefined)) {
                    if(!family.length) {
                        showNoti('부양가족 정보를 입력해주세요.');
                        window.location.href = '/survey#15';
                        return;
                    }
                    else{
                        for(let key in family) {
                            if (validationCheckFamily(family[key])) {
                                list.push(family[key]);
                            } else {
                                return;
                            }
                        }
                    }
                }

                const rentAmt = answer.rentAmt || 0;

                newState = {
                    ...newState,
                    family: list,
                    rentAmt: rentAmt
                }
                const rentlist = [];
                if (answer.rentYn === "1") {
                    if(answer.houseCnt === undefined || answer.houseCnt === '' ||
                        answer.storeCnt === undefined ||answer.storeCnt === ''){
                        window.window.location.href = '/survey#21';
                        showNoti('필수 입력 항목입니다.');
                        return;
                    }
                    if (answer.houseCnt > 0 && (Object.keys(rent.house).length === 0 || Object.keys(rent.house).length < answer.houseCnt)){
                        window.window.location.href = '/survey#22';
                        showNoti('주택 임대 정보를 입력하세요.');
                        return;
                    }
                    if (answer.storeCnt > 0 && (Object.keys(rent.commercial).length === 0 || Object.keys(rent.commercial).length < answer.storeCnt)){
                        window.window.location.href = '/survey#22';
                        showNoti('상가 임대 정보를 입력하세요.');
                        return;
                    }
                    for(let key in rent.house) {
                        const tmpHouse = rent.house[key];
                        if (tmpHouse.houseRentYn === "") { // 개인 세무사 진행
                            window.window.location.href = '/survey#22';
                            showNoti('필수 입력 항목입니다.');
                            return;
                        }
                        if(tmpHouse.houseRentYn === "1") {
                            if (tmpHouse.taxAccntYn === "1") { // 개인 세무사 진행
                                if (tmpHouse.taxAccntNm === "" || tmpHouse.taxAccntTelno === "") {
                                    window.window.location.href = '/survey#22';
                                    showNoti('필수 입력 항목입니다.');
                                    return;
                                }
                            } else if (tmpHouse.taxAccntYn === "0") {
                                if (tmpHouse.rentAgentNm === "" || tmpHouse.rentIncomeAmt === "" ||
                                    tmpHouse.jointYn === "" ||
                                    tmpHouse.stdMktAmt === "" || tmpHouse.ddcArea === "" ||
                                    tmpHouse.bizRegYn === "" || tmpHouse.rentBizYn === ""
                                ) {
                                    window.window.location.href = '/survey#22';
                                    showNoti('필수 입력 항목입니다.');
                                    return;
                                }
                                if (tmpHouse.jointYn === "1" && tmpHouse.shareRate === "") {
                                    window.window.location.href = '/survey#22';
                                    showNoti('필수 입력 항목입니다.');
                                    return;
                                }
                            } else {
                                window.window.location.href = '/survey#22';
                                showNoti('필수 입력 항목입니다.');
                                return;
                            }
                        }
                        rentlist.push(tmpHouse);
                    }

                    for(let key in rent.commercial) {
                        const tmpCommercial = rent.commercial[key];
                        // console.log(rent.commercial);
                        if (tmpCommercial.taxAccntYn === "1") { // 개인 세무사 진행
                            if (tmpCommercial.taxAccntNm === "" || tmpCommercial.taxAccntTelno === "") {
                                window.window.location.href = '/survey#23';
                                showNoti('필수 입력 항목입니다.');
                                return;
                            }
                        }
                        else if (tmpCommercial.taxAccntYn === "0") {
                            if( tmpCommercial.rentAgentNm === "" || tmpCommercial.rentIncomeAmt === "" ||
                              tmpCommercial.jointYn === "" ){

                            }
                            // console.log(tmpCommercial);
                            if(tmpCommercial.jointYn === "1" && tmpCommercial.shareRate ===""){
                                window.window.location.href = '/survey#23';
                                showNoti('필수 입력 항목입니다.');
                                return;
                            }
                        } else {
                            window.window.location.href = '/survey#23';
                            showNoti('필수 입력 항목입니다.');
                            return;
                        }

                        rentlist.push(tmpCommercial);
                    }

                    if(answer.preBizAmt === undefined || answer.preBizAmt === ''){
                        window.window.location.href = '/survey#24';
                        showNoti('필수 입력 항목입니다.');
                        return;
                    }
                    if( answer.midPrepAmt === undefined || answer.midPrepAmt === ''){
                        window.window.location.href = '/survey#25';
                        showNoti('필수 입력 항목입니다.');
                        return;
                    }
                    if( answer.optRentYn === undefined || answer.optRentYn === ''){
                        window.window.location.href = '/survey#26';
                        showNoti('필수 입력 항목입니다.');
                        return;
                    }
                } else {  // answer.rentYn === "0"
                }

                newState = {
                    ...newState,
                    rent: rentlist,
                    isValid: true
                }
                const tempContData = {
                    answer,
                    rent,
                    family
                }
                // console.log("최종 값 : ", newState);
                setAnswer(newState);
                client.post('/kognr/tmpCont', {
                    admnNo: userInfo.admnNo,
                    kognrTmpCont:  JSON.stringify(tempContData),
                }).catch((error) => {
                    console.log(error.response);
                }).then((res)=>{
                    history.push('/result');
                });

            }
        }
    };

    return (
        (agreeData && surveyData.length > 0) &&
        <>
            <Survey1 key={"comp-survey1"} compRef={compRefs}/>
            <Title key={"title-6"} step={6}/>
            <Survey0 key={"comp-survey0"} compRef={compRefs}/>
            <Survey2 key={"comp-survey2"} compRef={compRefs}/>
            <Address key={"address-9"} step={118} compRef={compRefs}/>
            <Survey2_1 key={"comp-survey2-1"} compRef={compRefs}/>
            <Survey3 key={"comp-survey3"} compRef={compRefs}/>
            <Survey4 key={"comp-survey4"} compRef={compRefs}/>
            <Survey5 key={"comp-survey5"} compRef={compRefs}/>
            <Survey6 key={"comp-survey6"} compRef={compRefs}/>
            <Title key={"title-14"} step={14}/>
            <Survey7 key={"comp-survey7"} compRef={compRefs}/>
            <Title key={"title-17"} step={17}/>
            <Survey8 key={"comp-survey8"}/>
            <Survey9 key={"comp-survey9"} setProcess={setIsProcess} />
            <Survey10 key={"comp-survey10"} compRef={compRefs} setProcess={setIsProcess} />
            <Survey11 key={"comp-survey11"} setProcess={setIsProcess} />
            <Survey12 key={"comp-survey12"} setProcess={setIsProcess} />
            <Title key={"title-30"} step={30}/>
            <Survey17/>
            <Survey15 compRef={compRefs} setProcess={setIsProcess}/>
            <Survey16 compRef={compRefs} setProcess={setIsProcess}/>
            <Title key={"title-113"} step={113}/>
            <Survey13 key={"comp-survey13"}/>
            <Survey14 key={"comp-survey14"}/>
            <Grid container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
            >
                <div className={classes.buttons}>
                    <Button
                        variant="contained"
                        className={classes.button}
                        id='next'
                        name='next'
                        value='next'
                        disabled={isProcess}
                        onClick={onClick}
                    >
                        다음단계
                    </Button>
                </div>
            </Grid>
            <a href="/pdf/주택임대소득 FAQ.pdf" target="_blank">
                <img src={FaqImg} className={classes.fab}/>
            </a>
        </>
    );
};

export default withRouter(SurveyForm);

